<template>
  <v-card class="pa-4" outlined>
    <v-card-text class="spacing-playground">
      <v-form ref="form">
        <v-row>
          <v-col cols="12" md="12">
            <p class="text-h6">Datos de la bahia</p>
          </v-col>
          <v-col class="mt-n5" cols="12" md="12">
            <v-text-field
              label="Nombre"
              v-model="nm"
              outlined
              dense
              required
            ></v-text-field>
          </v-col>
          <v-col class="mt-n5" cols="12" md="12">
            <v-text-field
              label="Orden"
              v-model="od"
              outlined
              dense
              required
            ></v-text-field>
          </v-col>
        </v-row>
        <div class="text-right">
          <v-btn large @click="$emit('toggle', false)">Cancelar</v-btn>
          <v-btn
            @click="checkForm()"
            style="margin-left: 6px"
            color="success"
            large
            >Guardar</v-btn
          >
        </div>
      </v-form>
    </v-card-text>
  </v-card>
</template>

<style scoped></style>

<script>
import { mapGetters } from "vuex";
export default {
  name: "BahiasForm",
  components: {},
  props: ["edit", "dataEdit"],
  data() {
    return {
      Id: "",
      nm: "",
      od: 0,
    };
  },
  computed: {},
  methods: {
    checkForm() {
      if (this.$refs.form.validate()) {
        let doAction = "CREATE";
        if (this.edit) {
          doAction = "EDIT";
        }
        this.send(doAction);
      }
    },
    send(action) {
      const dataSave = this.$data;

      this.$emit("successData", dataSave, action);
    },
  },
  mounted() {
    if (this.edit) {
      this.Id = this.dataEdit.id;
      this.nm = this.dataEdit.nm;
      this.od = this.dataEdit.od;
    }
  },
};
</script>
